import FilterInputItems from "../shared/Filter/FilterInputItems";
import {tableContentType} from "../shared/table/table_utils";

export const outletConstants = {
  filters: [
    FilterInputItems.id,
    FilterInputItems.title,
    FilterInputItems.status
  ],
  listAttributes: [
    {
      title: 'ID',
      field: 'id',
      type: tableContentType.ID,
    },
    {
      title: 'Code',
      field: 'code',
      type: tableContentType.TEXT,
    },
    {
      title: 'Name',
      field: 'name',
      type: tableContentType.TEXT,
    },
    {
      title: 'Channel',
      field: 'channel_title',
      type: tableContentType.TEXT,
    },
    {
      title: 'Route',
      field: 'route',
      type: tableContentType.TEXT,
    },
    {
      title: 'ASE',
      field: 'agent_name',
      type: tableContentType.TEXT,
    },
    {
      title: 'Region',
      field: 'region_title',
      type: tableContentType.TEXT,
    },
    {
      title: 'Area',
      field: 'area_title',
      type: tableContentType.TEXT,
    },
    {
      title: 'Territory',
      field: 'territory_title',
      type: tableContentType.TEXT,
    },
    {
      title: 'Town',
      field: 'town_title',
      type: tableContentType.TEXT,
    },
    {
      title: 'Status',
      field: 'status',
      type: tableContentType.STATUS,
    },
    {
      title: 'Created At',
      field: 'created_at',
      type: tableContentType.DATE_TIME,
    },
    {
      title: 'Action',
      field: 'action',
      type: tableContentType.ACTION,
    },
  ],
  detailsAttributes: [
    {
      title: 'ID',
      field: 'id',
      type: tableContentType.TEXT,
    },
    {
      title: 'Code',
      field: 'code',
      type: tableContentType.TEXT,
    },
    {
      title: 'Name',
      field: 'name',
      type: tableContentType.TEXT,
    },
    {
      title: 'Channel',
      field: 'channel_title',
      type: tableContentType.TEXT,
    },
    {
      title: 'Route',
      field: 'route',
      type: tableContentType.TEXT,
    },
    {
      title: 'Agent',
      field: 'agent_name',
      type: tableContentType.TEXT,
    },
    {
      title: 'Region',
      field: 'region_title',
      type: tableContentType.TEXT,
    },
    {
      title: 'Area',
      field: 'area_title',
      type: tableContentType.TEXT,
    },
    {
      title: 'Territory',
      field: 'territory_title',
      type: tableContentType.TEXT,
    },
    {
      title: 'Town',
      field: 'town_title',
      type: tableContentType.TEXT,
    },
    {
      title: 'Status',
      field: 'status',
      type: tableContentType.STATUS,
    },
    {
      title: 'Created At',
      field: 'created_at',
      type: tableContentType.DATE_TIME,
    },
  ]
}

